/**
 * Scrolls to the top of the page
 */
function scrollToTop(): void {
    window.scrollTo(0, 0);
}

export default scrollToTop;
